import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from 'flowbite-react';
import { Change } from '../../models';
import { Button, Icon } from '..';

export type FinishedTrackPromptModalProps = {
    show: boolean;
    change: Change;
    loading?: boolean;
    onClose?: () => void;
    onSwitchToFollowUp?: () => void;
    onCreateSuite: () => void;
};

function FinishedTrackPromptModal(props: FinishedTrackPromptModalProps) {
    const {
        show,
        change,
        loading,
        onClose,
        onSwitchToFollowUp,
        onCreateSuite,
    } = props;
    const { t } = useTranslation();

    if (!show)
        return null;

    const followUpSlug = change.followUpInto?.slug != null
        ? String(change.followUpInto.slug)
        : null;
    const hasFollowUp = !!(change.followUpInto?.change);

    return (
        <Modal show={show} size="md" dismissible onClose={onClose}>
            <Modal.Header>
                <div className="flex items-center gap-x-2 min-w-0">
                    <Icon type="timer" size={5} className="shrink-0" />
                    <span className="truncate">{t('changes.finished_track_title')}</span>
                </div>
            </Modal.Header>
            <Modal.Body>
                <p className="text-sm text-gray-600 dark:text-gray-300">
                    {hasFollowUp
                        ? t('changes.finished_track_hint_with_follow_up', { slug: followUpSlug })
                        : t('changes.finished_track_hint_create')}
                </p>
            </Modal.Body>
            <Modal.Footer className="flex flex-col sm:flex-row gap-2 sm:justify-end">
                <Button color="gray" onClick={onClose} disabled={!!loading}>
                    {t('common.cancel')}
                </Button>
                {hasFollowUp && onSwitchToFollowUp && (
                    <Button color="blue" onClick={onSwitchToFollowUp} disabled={!!loading}>
                        {loading
                            ? <Icon type="loading" size={4} />
                            : t('changes.finished_track_switch', { slug: followUpSlug })}
                    </Button>
                )}
                <Button color="blue" onClick={onCreateSuite} disabled={!!loading}>
                    {loading
                        ? <Icon type="loading" size={4} />
                        : t('changes.finished_track_create')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default FinishedTrackPromptModal;
